import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AwsService, HttpService } from '__services';
// import { Auth } from 'aws-amplify';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  isCalledLogout: boolean = false;

  constructor(
    private http: HttpService,
    private awsService: AwsService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(res => {
        if (res.status === 401 && !this.isCalledLogout) {
          this.isCalledLogout = true;
          this.http.post('/users/logout', {expired: true}).subscribe(
          ).add(() => {
            this.awsService.logout().finally();
            this.isCalledLogout = false;
          })
        }
        const error = {
          message: res.error.error ? res.error.error.message : res.message,
          name: res.error.error ? res.error.error.name : res.name,
          status: res.error.error ? res.error.error.statusCode : res.status,
          details: res?.error?.error?.details,
          code: res.error.error?.code ?? ""
        };
        return throwError(error);
      }));
  }
}
